// ========== plugin import ======== //
import {useState, useEffect, useRef} from 'react'
import Swal from 'sweetalert2';
import axios from 'axios';
// ========== component import ========== //
import AddFeature from './component/AddFeature';
import FeatureList from './component/FeatureList';
import UpdateFeatureDrawer from './component/UpdateFeatureDrawer';
import SideDrawer from '../../../../../../../../component/common/SideDrawer';

const FeatureSetup = (props) => {
    const {
        formValidateError,
        formData,
    } = props;

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    // ----- define all state here ------- //
    const [ featureUpdateIndex, setFeatureUpdateIndex ] = useState(-1);
    const [ featureList , setFeatureList ] = useState([]);
    const [featureUpdateDrawerIsOpen, setFeatureUpdateDrawerIsOpen] = useState(false);
    const [ updateFeatureList, setUpdateFeatureList ] = useState([]);
    const [featureStateIsChange, setFeatureStateIsChange] = useState(false)
    const [isupdateInfoOpen, setIsupdateInfoOpen] = useState('')

    const [isButtonLoader, setIsButtonLoader] = useState(false);

    const featureSaveHandler = async (feature) => {
        setFeatureStateIsChange(true)
        let featureSynonyms = [];
        if(feature.feature_synonyms !== ''){
            featureSynonyms = JSON.parse(feature.feature_synonyms)
        }
        if(Object.keys(feature).length > 0){
            const newFeature = {
                feature_name: feature.feature_name,
                feature_synonyms: featureSynonyms,
            };
            let isDuplicate = false;
            if(formData['step3'].features_setup.feature_name !== ''){
                isDuplicate = formData['step3'].features_setup.some(
                    (features) => features.feature_name.trim() === feature.feature_name.trim()
                );
            }
            if(featureUpdateIndex < 0){
                // --- insert --- //
                if (isDuplicate) {
                    await Swal.fire({
                        text: 'Duplicate feature name cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }
                setIsButtonLoader(true)
                setFeatureList((prevList) => [...prevList, newFeature]);
                props.onInputChange(
                    'step3',
                    'features_setup',
                    [
                        ...(Array.isArray(formData['step3'].features_setup) ? formData['step3'].features_setup : []),
                        {
                            feature_name: newFeature.feature_name,
                            feature_synonyms: newFeature.feature_synonyms
                        }
                    ]
                );
            }
            else{
                const updatedFeatureState = [...formData['step3'].features_setup];
                if(updatedFeatureState[featureUpdateIndex].feature_name !== newFeature.feature_name){
                    if (isDuplicate) {
                        await Swal.fire({
                            text: 'Duplicate feature name cannot be added !',
                            icon: 'error',
                            showCancelButton: true,
                            showConfirmButton : false,
                            cancelButtonText: 'OK',
                        });
                        return;
                    }
                }

                setIsButtonLoader(true)

                let old_feature_name = updatedFeatureState[featureUpdateIndex].feature_name;
                let new_feature_name = newFeature.feature_name;
                // ----------- update product_features_association --------- //
                const associationDataState = formData['step3'].product_features_association;
                const updatedState = Object.fromEntries(
                    Object.entries(associationDataState).map(([key, arr]) => [
                        key,
                        {
                            feature_list: arr.feature_list.map(obj => 
                                obj.label === old_feature_name 
                                    ? { ...obj, label: new_feature_name, value: new_feature_name }
                                    : obj
                            )
                        }
                    ])
                );
                props.onInputChange('step3', 'product_features_association', updatedState);
                // -------- update product_features_association_data -------- //
                const upPfAssData = formData['step3'].product_features_association_data;
                if(upPfAssData.length > 0){
                    var needArr = upPfAssData.map((item) => {
                        return {
                            ...item,
                            select_association: item.select_association.map((assoc) => {
                                return {
                                    label: assoc.label.includes(`Feature: ${old_feature_name}`)
                                        ? assoc.label.replace(`Feature: ${old_feature_name}`, `Feature: ${new_feature_name}`)
                                        : assoc.label,
                                    value: assoc.value.includes(`Feature: ${old_feature_name}`)
                                        ? assoc.value.replace(`Feature: ${old_feature_name}`, `Feature: ${new_feature_name}`)
                                        : assoc.value,
                                };
                            }),
                        };
                    });
                    props.onInputChange(
                        'step3',
                        'product_features_association_data',
                        needArr
                    );
                }

                // ---------- update features_setup --------- //
                updatedFeatureState[featureUpdateIndex] = newFeature;
                setFeatureList(updatedFeatureState);
                props.onInputChange(
                    'step3',
                    'features_setup',
                    updatedFeatureState
                );
                setFeatureUpdateDrawerIsOpen(false);
                props.featureSetupApiIsCall(true)
            }
            setFeatureUpdateIndex(-1)
        }
    }

    const featureUpdateHandler = (index) => {
        setUpdateFeatureList([featureList[index]])
        setFeatureUpdateIndex(index)
        setFeatureUpdateDrawerIsOpen(true)
    }

    const featureDeleteHandler = (index) => {
        setFeatureStateIsChange(true)
        const updatedFeatureList = [...featureList];
        const deleteFeatureName = updatedFeatureList[index].feature_name;
        // --------- delete product_features_association --------- //
        const associationDataState = formData['step3'].product_features_association;
        if( Object.keys(associationDataState).length > 0 ){
            let updatedData = {};
           
            Object.keys(associationDataState).forEach((product) => {
                const updatedFeatureList = associationDataState[product].feature_list.filter(
                  (feature) => feature.value !== deleteFeatureName
                );
                if (updatedFeatureList.length > 0) {
                  updatedData[product] = {
                    ...associationDataState[product], 
                    feature_list: updatedFeatureList
                  };
                }
            });
            props.onInputChange(
                'step3',
                'product_features_association',
                updatedData
            );
        }
        // -------- delete product_features_association_data -------- //
        let pfAssData = formData['step3'].product_features_association_data;
        if( pfAssData.length > 0 ){
            const filterData = (data, featureToRemove) => {
                return data
                .map((item) => ({
                ...item,
                select_association: item.select_association.filter(
                    (assoc) => !assoc.value.includes(`Feature: ${featureToRemove}`)
                ),
                }))
                .filter((item) => item.select_association.length > 0);
            };
            const pfAssDataUpdate =  filterData(pfAssData, deleteFeatureName);

            props.onInputChange(
                'step3',
                'product_features_association_data',
                pfAssDataUpdate
            );
        }
        // ------- feature state change ------- //
        updatedFeatureList.splice(index, 1);
        setFeatureList(updatedFeatureList);
        props.onInputChange(
            'step3',
            'features_setup',
            updatedFeatureList
        );
        props.featureSetupApiIsCall(true)
    }

    const featuresListOnDropHandler = (rearrangeFeatureData) => {
        setFeatureStateIsChange(true)
        setFeatureList(rearrangeFeatureData);
        props.onInputChange(
            'step3',
            'features_setup',
            rearrangeFeatureData
        );
    }

    useEffect(() => {
        setFeatureStateIsChange(false)
        setFeatureList(formData['step3'].features_setup);
    },[formData['step3']]);

    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            feature_setup_update_drawer: () => {
                setFeatureUpdateDrawerIsOpen(false); 
                setFeatureUpdateIndex(-1)
            },
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }

    // ------ feature setup api call -------- //
    const formRef = useRef();
    useEffect(() => {
        const saveFeaturesDetails = async () => {
            if(!featureStateIsChange) return;
            const saveFeatureData = async () => {
                let features = [];
                if(featureList.length > 0){
                    const indexedFeatures = featureList.map((feature, index) => ({
                        ...feature,
                        index,
                    }));
                    features = indexedFeatures
                }
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                let featureFormData = new FormData();
                featureFormData.append("action_type", 'features_setup');
                featureFormData.append("bot_id", formData.bot_id);
                featureFormData.append("step", "step3");
                featureFormData.append("data", JSON.stringify(features));
                featureFormData.append("sass_id", localStorage.getItem('sass_id'));
                featureFormData.append("user_type", localStorage.getItem('type'));
                featureFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');
                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, featureFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            featureFormData = new FormData();
                            setFeatureStateIsChange(false)
                            formRef.current?.resetForm();
                            setIsButtonLoader(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            };
            await saveFeatureData();
        };
        saveFeaturesDetails();
    }, [featureList]);

    return (
        <>
            <div className="row border border-dashed border-gray-400 rounded p-5 mb-5">
                <a className="fw-bold text-gray-800 mb-2 fs-3">Add Feature/Selection</a>
                <div className="col-md-12">
                    <AddFeature
                        featureSave = {featureSaveHandler}
                        updateFeatureList = {updateFeatureList}
                        formValidateError = {formValidateError}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={formRef}
                        isButtonLoader={isButtonLoader}
                    />
                </div>
                <FeatureList
                    featureList ={featureList}
                    featureUpdateOnClick={featureUpdateHandler}
                    featureDeleteOnClick = {featureDeleteHandler}
                    featuresListOnDrop={featuresListOnDropHandler}
                />
            </div>
            <SideDrawer
                title={'Feature Data Update'}
                width={isupdateInfoOpen=== 'open' ? 900 : 600}
                open={featureUpdateDrawerIsOpen}
                drawer_name={'feature_setup_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <UpdateFeatureDrawer
                    featureSave = {featureSaveHandler}
                    updateFeatureList = {updateFeatureList}
                    formValidateError = {formValidateError}
                    ref={formRef}
                    isButtonLoader={isButtonLoader}

                    isUpdateInfo= {(data) => setIsupdateInfoOpen(data.isOpen)}
                    drawerIsOpen={featureUpdateDrawerIsOpen}
                />
            </SideDrawer>
        </>
    )
}

export default FeatureSetup
